module.exports = __webpack_public_path__ + "7a7caf4424b975696dd1feeed009b0c9.fbx";